/* eslint-disable no-debugger */
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack5';
import { Form, FormikProvider, useFormik } from 'formik';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
// material
import {
  Card,
  Grid,
  Stack,
  TextField,
  Autocomplete,
  Checkbox,
  Button,
  Typography,
  TableContainer,
  Table,
  Paper,
  TableBody,
  TableCell,
  TableRow
} from '@material-ui/core';
import FullDialog from '../../common-components/FullDialog';
import CustomerTableData from './CustomerTableData';
// ----------------------------------------------------------------------

CustomerSearchForm.propTypes = {
  //
};

export default function CustomerSearchForm() {
  const { enqueueSnackbar } = useSnackbar();
  const [showResult, setShowResult] = useState(false);

  const TABLE_HEAD = [
    {
      label: 'Client'
    },
    {
      label: 'Project'
    },
    {
      label: 'Vendor'
    },
    {
      label: 'Smartcollect Account Id'
    },
    {
      label: 'Customer Identifier'
    },
    {
      label: 'Date of Assignment'
    },
    {
      label: 'Expired'
    },
    {
      label: 'Name'
    },
    {
      label: ''
    }
  ];

  const customerData = [
    {
      Client: 'Citi Bank'
    },
    {
      Project: 'Citi Credit Card'
    },
    {
      Vendor: 'CP360 internal'
    },
    {
      'Smartcollect Acount ID': 'P123-G00384'
    },
    {
      'Customer Identifier': 'G00384'
    },
    {
      'Date of Assignment': '12-mar-23'
    },
    {
      'Days to Expire': 120
    },
    {
      'Expiration / Reassignment date': '12-jun-23'
    },
    {
      Expired: 'No'
    },
    {
      'First Name': 'Rakesh'
    },
    {
      'Last Name': 'Ranjan'
    },
    {
      Name: 'Rakesh Ranjan'
    },
    {
      DOB: '12-oct-99'
    },
    {
      Age: 24
    },
    {
      Phone1: 7463830613
    },
    {
      Phone2: 7463830613
    },
    {
      Email1: 'rr.dev530@gmail.com'
    },
    {
      Email2: 'dahingranjan1213@gmail.com'
    },
    {
      'Address Line1': 'Patna'
    },
    {
      'Address Line2': 'Patna'
    },
    {
      'Address Line3': 'Patna'
    },
    {
      City: 'Phulwari'
    },
    {
      State: 'Bihar'
    },
    {
      'ZIP/PIN': 801505
    },
    {
      'other mapped columns': ''
    }
  ];

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      client: [],
      project: [],
      vendor: [],
      vendor_type: []
    },
    onSubmit: async (values, { setSubmitting, setErrors }) => {
      try {
        console.log(values);
        setSubmitting(false);
      } catch (error) {
        console.error(error);
        setErrors(error);
        setSubmitting(false);
      }
    }
  });
  const { values, handleSubmit, getFieldProps } = formik;

  const handleShowResult = () => {
    setShowResult(!showResult);
  };

  return (
    <FormikProvider value={formik}>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Card sx={{ p: 3 }}>
              <Stack spacing={3}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                  <Autocomplete
                    fullWidth
                    multiple
                    name="client"
                    value={values?.client ? values?.client : null}
                    options={[]}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox checked={selected} />
                        {option?.client_name}
                      </li>
                    )}
                    getOptionLabel={(option) => (option ? option?.client_name : '')}
                    renderInput={(params) => <TextField {...params} label="Client" margin="none" />}
                  />
                  <Autocomplete
                    fullWidth
                    multiple
                    name="project"
                    value={values?.project ? values?.project : null}
                    options={[]}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox checked={selected} />
                        {option?.project_name}
                      </li>
                    )}
                    getOptionLabel={(option) => (option ? option?.project_name : '')}
                    renderInput={(params) => <TextField {...params} label="Project" margin="none" />}
                  />
                </Stack>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                  <Autocomplete
                    fullWidth
                    multiple
                    name="vendor"
                    value={values?.vendor ? values?.vendor : null}
                    options={[]}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox checked={selected} />
                        {option?.vendor_name}
                      </li>
                    )}
                    getOptionLabel={(option) => (option ? option?.vendor_name : '')}
                    renderInput={(params) => <TextField {...params} label="Vendor" margin="none" />}
                  />
                  <Autocomplete
                    fullWidth
                    multiple
                    name="vendorType"
                    value={values?.vendor_type ? values?.vendor_type : null}
                    options={[]}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox checked={selected} />
                        {option?.vendorType}
                      </li>
                    )}
                    getOptionLabel={(option) => (option ? option?.vendorType : '')}
                    renderInput={(params) => <TextField {...params} label="Vendor Type" margin="none" />}
                  />
                </Stack>

                <Stack width="50%" direction="column" spacing={3}>
                  <TextField
                    label="SmartCollect Account Id"
                    name="smartCollectId"
                    {...getFieldProps('smartCollectId')}
                  />
                  <TextField label="Customer Identifier" name="custIdentifier" {...getFieldProps('custIdentifier')} />
                  <TextField label="Customer Name" name="custName" {...getFieldProps('custName')} />
                  <TextField label="Customer Email" name="custEmail" {...getFieldProps('custEmail')} />
                  <TextField label="Customer Contact" name="custContact" {...getFieldProps('custContact')} />
                </Stack>
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={{ xs: 3, sm: 2 }}
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <TextField
                    sx={{ width: '50%' }}
                    label="Other Fields"
                    name="otherField"
                    {...getFieldProps('otherField')}
                  />
                  <Button variant="contained">Clear All</Button>
                  <Typography variant="subtitle2">....2 results found</Typography>
                  <Button variant="contained" onClick={handleShowResult}>
                    Show Results
                  </Button>
                </Stack>
                {showResult && (
                  <Paper>
                    <Stack spacing={3}>
                      <Typography variant="h5">Results</Typography>
                      <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
                        <TableContainer>
                          <Table sx={{ border: 1 }}>
                            <TableBody>
                              <TableRow sx={{ backgroundColor: '#3cb37117', border: 1 }}>
                                {TABLE_HEAD?.map((label, index) => (
                                  <TableCell style={{ border: '1px solid', padding: '10px' }} key={index}>
                                    {label?.label}
                                  </TableCell>
                                ))}
                              </TableRow>
                              <TableRow>
                                <TableCell style={{ border: '1px solid', padding: '8px' }}>rakesh</TableCell>
                                <TableCell style={{ border: '1px solid', padding: '8px' }}>rakesh</TableCell>
                                <TableCell style={{ border: '1px solid', padding: '8px' }}>rakesh</TableCell>
                                <TableCell style={{ border: '1px solid', padding: '8px' }}>rakesh</TableCell>
                                <TableCell style={{ border: '1px solid', padding: '8px' }}>rakesh</TableCell>
                                <TableCell style={{ border: '1px solid', padding: '8px' }}>rakesh</TableCell>
                                <TableCell style={{ border: '1px solid', padding: '8px' }}>rakesh</TableCell>
                                <TableCell style={{ border: '1px solid', padding: '8px' }}>rakesh</TableCell>
                                <TableCell style={{ border: '1px solid', padding: '8px' }}>
                                  {/* <IconButton>
                                    <Icon color="inherit" icon={eyeFill} />
                                  </IconButton> */}
                                  <FullDialog
                                    icon={eyeFill}
                                    showIcon
                                    data={customerData}
                                    backButtonTitle="Back to search"
                                    CalledComponent={CustomerTableData}
                                  />
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Stack>
                    </Stack>
                  </Paper>
                )}
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  );
}
